import { createContext, useContext, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useAuth } from '@/hooks/use-auth';
export const NudgeManager = createContext({
  showNudge: false,
  onCancel: () => {},
});

NudgeManager.displayName = 'NudgeManager';

export const useTrailNudge = () => {
  const contextValue = useContext(NudgeManager);
  return contextValue;
};

export const useShowNudge = () => {
  const { currUser } = useAuth();
  const [showNudge, setShowNudge] = useState(false);

  useEffect(() => {
    const dismissedTime = Number(
      localStorage.getItem('trialNudgeDismissedTime')
    );
    if (dismissedTime) {
      const diffHours = dayjs(Date.now()).diff(dismissedTime, 'hour');
      if (diffHours < 24) {
        setShowNudge(false);
        return;
      }
      if (diffHours >= 24) {
        setShowNudge(true);
        localStorage.removeItem('trialNudgeDismissedTime');
        return;
      }
    }
    setShowNudge(true);
  }, []);

  const onCancel = () => {
    setShowNudge(false);
    localStorage.setItem('trialNudgeDismissedTime', Date.now());
  };

  return {
    showNudge: showNudge && currUser?.account?.status === 'trial',
    onCancel,
  };
};

export const NudgeManagerProvider = NudgeManager.Provider;
